import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setNotAssignedProjectGroupUserSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectUser = (user: MtUser) => {
        let selectedCopy
        if (selected && selected.includes(user.id)) {
            selectedCopy = selected.filter((id) => (id !== user.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(user.id)
        }
        dispatch(setNotAssignedProjectGroupUserSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectUser,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (user: MtUser) => <UserIcon user={user} size="sm" />,
            onClick: selectUser,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => false,
        },
    ]

    return columns
}
export default Columns
